<template>
  <div class="payments">
    <div class="table">
      <div class="table__header box box--default">
        <div class="table__label table__label--medium table__label--fixed">    {{ $t(`accountDetails.${"paymentsTable"}.${"header"}.${"status"}`) }}</div>
        <div class="table__label table__label--medium"> {{ $t(`accountDetails.${"paymentsTable"}.${"header"}.${"policyNr"}`) }}</div>
        <div class="table__label table__label--medium"> {{ $t(`accountDetails.${"paymentsTable"}.${"header"}.${"issuanceDate"}`) }}</div>
        <div class="table__label table__label--medium"> {{ $t(`accountDetails.${"paymentsTable"}.${"header"}.${"Insurer"}`) }}</div>
        <div class="table__label table__label--large"> {{ $t(`accountDetails.${"paymentsTable"}.${"header"}.${"industry"}`) }}</div>
        <div class="table__label table__label--medium"> {{ $t(`accountDetails.${"paymentsTable"}.${"header"}.${"payment"}`) }}</div>
        <div class="table__label table__label--medium"> {{ $t(`accountDetails.${"paymentsTable"}.${"header"}.${"reportPayment"}`) }}</div>
        <div class="table__label table__label--medium table__label--last"></div>
      </div>

      <div class="table__body">
        <Loading v-if="detailsLoading" />
        <template v-else>
          <PolicyInvoice v-for="policy in policies" :key="policy.id" :policy="policy" :expandInvoice="expandInvoice"
            :expandedInvoices="expandedInvoices" />
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import PolicyInvoice from "@/components/AccountDetails/PolicyInvoice";
import Loading from "@/partials/Loading";

defineOptions({
  name: "Invoices"
});

const {policies, detailsLoading} = defineProps({
  policies: {
    required: true,
    type: Array,
  },
  detailsLoading: {
    required: true,
    type: Boolean,
  },
});

// State
const expandedInvoices = ref([]);

// Methods
const expandInvoice = (id) => {
  const index = expandedInvoices.value.indexOf(id);
  if (index > -1) {
    expandedInvoices.value.splice(index, 1);
  } else {
    expandedInvoices.value = [...expandedInvoices.value, id];
  }
};
</script>